const kanjiNumbers = [
  {
    ten_romaji: "+",
    hundred_romaji: "+",
    thousand_romaji: "+",
    tenthousand_romaji: "*",
    ten_1: "0",
    ten_romaji_1: "rē",
    ten_2: "10",
    ten_romaji_2: "jū",
    ten_3: "20",
    ten_romaji_3: "nijū",
    ten_4: "30",
    ten_romaji_4: "sanjū",
    ten_5: "40",
    ten_romaji_5: "yonjū",
    ten_6: "50",
    ten_romaji_6: "gojū",
    ten_7: "60",
    ten_romaji_7: "rokujū",
    ten_8: "70",
    ten_romaji_8: "nanajū",
    ten_9: "80",
    ten_romaji_9: "hachijū",
    ten_10: "90",
    ten_romaji_10: "kyūjū",
    hundred_1: "100",
    hundred_romaji_1: "hyaku",
    hundred_2: "200",
    hundred_romaji_2: "nihyaku",
    hundred_3: "300",
    hundred_romaji_3: "sanbyaku",
    hundred_4: "400",
    hundred_romaji_4: "yonhyaku",
    hundred_5: "500",
    hundred_romaji_5: "gohyaku",
    hundred_6: "600",
    hundred_romaji_6: "roppyaku",
    hundred_7: "700",
    hundred_romaji_7: "nanahyaku",
    hundred_8: "800",
    hundred_romaji_8: "happyaku",
    hundred_9: "900",
    hundred_romaji_9: "kyūhyaku",
    thousand_1: "10",
    thousand_romaji_1: "sen",
    thousand_2: "2000",
    thousand_romaji_2: "nisen",
    thousand_3: "3000",
    thousand_romaji_3: "sanzen",
    thousand_4: "4000",
    thousand_romaji_4: "yonsen",
    thousand_5: "5000",
    thousand_romaji_5: "gosen",
    thousand_6: "6000",
    thousand_romaji_6: "rokusen",
    thousand_7: "7000",
    thousand_romaji_7: "nanasen",
    thousand_8: "8000",
    thousand_romaji_8: "hassen",
    thousand_9: "9000",
    thousand_romaji_9: "kyūsen",
    tenthousand: "10",
    tenthousand_elevated_1: "4",
    tenthousand_romaji_1: "man",
    tenthousand_elevated_2: "8",
    tenthousand_romaji_2: "oku",
    tenthousand_elevated_3: "12",
    tenthousand_romaji_3: "chō",
    tenthousand_elevated_4: "16",
    tenthousand_romaji_4: "kē",
    tenthousand_elevated_5: "20",
    tenthousand_romaji_5: "gai",
    tenthousand_elevated_6: "24",
    tenthousand_romaji_6: "jo",
    tenthousand_elevated_7: "28",
    tenthousand_romaji_7: "jō",
    tenthousand_elevated_8: "32",
    tenthousand_romaji_8: "kō",
    tenthousand_elevated_9: "36",
    tenthousand_romaji_9: "kan",
  },
  {
    ten_romaji: "9",
    ten_romaji_top: "kyū",
    hundred_romaji: "90",
    hundred_romaji_top: "kyūjū",
    thousand_romaji: "900",
    thousand_romaji_top: "kyūhyaku",
    tenthousand_romaji: "10",
    tenthousand_romaji_top: "sen",
    tenthousand_elevated_top: "3",
    ten_alternative: "[4]",
    tenthousand_alternative: "[5]",
    ten_1: "九",
    ten_2: "十九",
    ten_3: "二十九",
    ten_4: "三十九",
    ten_5: "四十九",
    ten_6: "五十九",
    ten_7: "六十九",
    ten_8: "七十九",
    ten_9: "八十九",
    ten_10: "九十九",
    hundred_1: "百九十",
    hundred_2: "二百九十",
    hundred_3: "三百九十",
    hundred_4: "四百九十",
    hundred_5: "五百九十",
    hundred_6: "六百九十",
    hundred_7: "七百九十",
    hundred_8: "八百九十",
    hundred_9: "九百九十",
    thousand_1: "千九百",
    thousand_2: "二千九百",
    thousand_3: "三千九百",
    thousand_4: "四千九百",
    thousand_5: "五千九百",
    thousand_6: "六千九百",
    thousand_7: "七千九百",
    thousand_8: "八千九百",
    thousand_9: "九千九百",
    tenthousand_1: "千万",
    tenthousand_2: "千億",
    tenthousand_3: "千兆",
    tenthousand_4: "千京",
    tenthousand_5: "千垓",
    tenthousand_6: "千𥝱",
    tenthousand_7: "千穣",
    tenthousand_8: "千溝",
    tenthousand_9: "千澗",
  },
  {
    ten_romaji: "8",
    ten_romaji_top: "hachi",
    hundred_romaji: "80",
    hundred_romaji_top: "hachijū",
    thousand_romaji: "800",
    thousand_romaji_top: "happyaku",
    tenthousand_romaji: "100",
    tenthousand_romaji_top: "hyaku",
    ten_1: "八",
    ten_2: "十八",
    ten_3: "二十八",
    ten_4: "三十八",
    ten_5: "四十八",
    ten_6: "五十八",
    ten_7: "六十八",
    ten_8: "七十八",
    ten_9: "八十八",
    ten_10: "九十八",
    hundred_1: "百八十",
    hundred_2: "二百八十",
    hundred_3: "三百八十",
    hundred_4: "四百八十",
    hundred_5: "五百八十",
    hundred_6: "六百八十",
    hundred_7: "七百八十",
    hundred_8: "八百八十",
    hundred_9: "九百八十",
    thousand_1: "千八百",
    thousand_2: "二千八百",
    thousand_3: "三千八百",
    thousand_4: "四千八百",
    thousand_5: "五千八百",
    thousand_6: "六千八百",
    thousand_7: "七千八百",
    thousand_8: "八千八百",
    thousand_9: "九千八百",
    tenthousand_1: "百万",
    tenthousand_2: "百億",
    tenthousand_3: "百兆",
    tenthousand_4: "百京",
    tenthousand_romaji_4: "hyakkē",
    tenthousand_5: "百垓",
    tenthousand_6: "百𥝱",
    tenthousand_7: "百穣",
    tenthousand_8: "百溝",
    tenthousand_romaji_8: "hyakkō",
    tenthousand_9: "百澗",
    tenthousand_romaji_9: "hyakkan",
  },
  {
    ten_romaji: "7",
    ten_romaji_top: "nana",
    hundred_romaji: "70",
    hundred_romaji_top: "nanajū",
    thousand_romaji: "700",
    thousand_romaji_top: "nanahyaku",
    tenthousand_romaji: "10",
    tenthousand_romaji_top: "jū",
    ten_alternative: "[3]",
    ten_1: "七",
    ten_2: "十七",
    ten_3: "二十七",
    ten_4: "三十七",
    ten_5: "四十七",
    ten_6: "五十七",
    ten_7: "六十七",
    ten_8: "七十七",
    ten_9: "八十七",
    ten_10: "九十七",
    hundred_1: "百七十",
    hundred_2: "二百七十",
    hundred_3: "三百七十",
    hundred_4: "四百七十",
    hundred_5: "五百七十",
    hundred_6: "六百七十",
    hundred_7: "七百七十",
    hundred_8: "八百七十",
    hundred_9: "九百七十",
    thousand_1: "千七百",
    thousand_2: "二千七百",
    thousand_3: "三千七百",
    thousand_4: "四千七百",
    thousand_5: "五千七百",
    thousand_6: "六千七百",
    thousand_7: "七千七百",
    thousand_8: "八千七百",
    thousand_9: "九千七百",
    tenthousand_1: "十万",
    tenthousand_2: "十億",
    tenthousand_3: "十兆",
    tenthousand_romaji_3: "jutchō",
    tenthousand_4: "十京",
    tenthousand_romaji_4: "jukkei",
    tenthousand_5: "十垓",
    tenthousand_6: "十𥝱",
    tenthousand_7: "十穣",
    tenthousand_8: "十溝",
    tenthousand_romaji_8: "jukkō",
    tenthousand_9: "十澗",
    tenthousand_romaji_9: "jukkan",
  },
  {
    ten_romaji: "6",
    ten_romaji_top: "roku",
    hundred_romaji: "60",
    hundred_romaji_top: "rokujū",
    thousand_romaji: "600",
    thousand_romaji_top: "roppyaku",
    tenthousand_romaji: "1",
    tenthousand_romaji_top: "ichi",
    ten_1: "六",
    ten_2: "十六",
    ten_3: "二十六",
    ten_4: "三十六",
    ten_5: "四十六",
    ten_6: "五十六",
    ten_7: "六十六",
    ten_8: "七十六",
    ten_9: "八十六",
    ten_10: "九十六",
    hundred_1: "百六十",
    hundred_2: "二百六十",
    hundred_3: "三百六十",
    hundred_4: "四百六十",
    hundred_5: "五百六十",
    hundred_6: "六百六十",
    hundred_7: "七百六十",
    hundred_8: "八百六十",
    hundred_9: "九百六十",
    thousand_1: "千六百",
    thousand_2: "二千六百",
    thousand_3: "三千六百",
    thousand_4: "四千六百",
    thousand_5: "五千六百",
    thousand_6: "六千六百",
    thousand_7: "七千六百",
    thousand_8: "八千六百",
    thousand_9: "九千六百",
    tenthousand_1: "一万",
    tenthousand_2: "一億",
    tenthousand_3: "一兆",
    tenthousand_romaji_3: "itchō",
    tenthousand_4: "一京",
    tenthousand_romaji_4: "ikkei",
    tenthousand_5: "一垓",
    tenthousand_6: "一𥝱",
    tenthousand_7: "一穣",
    tenthousand_8: "一溝",
    tenthousand_romaji_8: "ikkō",
    tenthousand_9: "一澗",
    tenthousand_romaji_9: "ikkan",
  },
  {
    ten_romaji: "5",
    ten_romaji_top: "go",
    hundred_romaji: "50",
    hundred_romaji_top: "gojū",
    thousand_romaji: "500",
    thousand_romaji_top: "gohyaku",
    ten_1: "五",
    ten_2: "十五",
    ten_3: "二十五",
    ten_4: "三十五",
    ten_5: "四十五",
    ten_6: "五十五",
    ten_7: "六十五",
    ten_8: "七十五",
    ten_9: "八十五",
    ten_10: "九十五",
    hundred_1: "百五十",
    hundred_2: "二百五十",
    hundred_3: "三百五十",
    hundred_4: "四百五十",
    hundred_5: "五百五十",
    hundred_6: "六百五十",
    hundred_7: "七百五十",
    hundred_8: "八百五十",
    hundred_9: "九百五十",
    thousand_1: "千五百",
    thousand_2: "二千五百",
    thousand_3: "三千五百",
    thousand_4: "四千五百",
    thousand_5: "五千五百",
    thousand_6: "六千五百",
    thousand_7: "七千五百",
    thousand_8: "八千五百",
    thousand_9: "九千五百",
  },
  {
    ten_romaji: "4",
    ten_romaji_top: "yon",
    hundred_romaji: "40",
    hundred_romaji_top: "yonjū",
    thousand_romaji: "400",
    thousand_romaji_top: "yonhyaku",
    ten_alternative: "[2]",
    ten_1: "四",
    ten_2: "十四",
    ten_3: "二十四",
    ten_4: "三十四",
    ten_5: "四十四",
    ten_6: "五十四",
    ten_7: "六十四",
    ten_8: "七十四",
    ten_9: "八十四",
    ten_10: "九十四",
    hundred_1: "百四十",
    hundred_2: "二百四十",
    hundred_3: "三百四十",
    hundred_4: "四百四十",
    hundred_5: "五百四十",
    hundred_6: "六百四十",
    hundred_7: "七百四十",
    hundred_8: "八百四十",
    hundred_9: "九百四十",
    thousand_1: "千四百",
    thousand_2: "二千四百",
    thousand_3: "三千四百",
    thousand_4: "四千四百",
    thousand_5: "五千四百",
    thousand_6: "六千四百",
    thousand_7: "七千四百",
    thousand_8: "八千四百",
    thousand_9: "九千四百",
  },
  {
    ten_romaji: "3",
    ten_romaji_top: "san",
    hundred_romaji: "30",
    hundred_romaji_top: "sanjū",
    thousand_romaji: "300",
    thousand_romaji_top: "sanbyaku",
    ten_1: "三",
    ten_2: "十三",
    ten_3: "二十三",
    ten_4: "三十三",
    ten_5: "四十三",
    ten_6: "五十三",
    ten_7: "六十三",
    ten_8: "七十三",
    ten_9: "八十三",
    ten_10: "九十三",
    hundred_1: "百三十",
    hundred_2: "二百三十",
    hundred_3: "三百三十",
    hundred_4: "四百三十",
    hundred_5: "五百三十",
    hundred_6: "六百三十",
    hundred_7: "七百三十",
    hundred_8: "八百三十",
    hundred_9: "九百三十",
    thousand_1: "千三百",
    thousand_2: "二千三百",
    thousand_3: "三千三百",
    thousand_4: "四千三百",
    thousand_5: "五千三百",
    thousand_6: "六千三百",
    thousand_7: "七千三百",
    thousand_8: "八千三百",
    thousand_9: "九千三百",
  },
  {
    ten_romaji: "2",
    ten_romaji_top: "ni",
    hundred_romaji: "20",
    hundred_romaji_top: "nijū",
    thousand_romaji: "200",
    thousand_romaji_top: "nihyaku",
    ten_1: "二",
    ten_2: "十二",
    ten_3: "二十二",
    ten_4: "三十二",
    ten_5: "四十二",
    ten_6: "五十二",
    ten_7: "六十二",
    ten_8: "七十二",
    ten_9: "八十二",
    ten_10: "九十二",
    hundred_1: "百二十",
    hundred_2: "二百二十",
    hundred_3: "三百二十",
    hundred_4: "四百二十",
    hundred_5: "五百二十",
    hundred_6: "六百二十",
    hundred_7: "七百二十",
    hundred_8: "八百二十",
    hundred_9: "九百二十",
    thousand_1: "千二百",
    thousand_2: "二千二百",
    thousand_3: "三千二百",
    thousand_4: "四千二百",
    thousand_5: "五千二百",
    thousand_6: "六千二百",
    thousand_7: "七千二百",
    thousand_8: "八千二百",
    thousand_9: "九千二百",
  },
  {
    ten_romaji: "1",
    ten_romaji_top: "ichi",
    hundred_romaji: "10",
    hundred_romaji_top: "jū",
    thousand_romaji: "100",
    thousand_romaji_top: "hyaku",
    ten_1: "一",
    ten_2: "十一",
    ten_3: "二十一",
    ten_4: "三十一",
    ten_5: "四十一",
    ten_6: "五十一",
    ten_7: "六十一",
    ten_8: "七十一",
    ten_9: "八十一",
    ten_10: "九十一",
    hundred_1: "百十",
    hundred_2: "二百十",
    hundred_3: "三百十",
    hundred_4: "四百十",
    hundred_5: "五百十",
    hundred_6: "六百十",
    hundred_7: "七百十",
    hundred_8: "八百十",
    hundred_9: "九百十",
    thousand_1: "千百",
    thousand_2: "二千百",
    thousand_3: "三千百",
    thousand_4: "四千百",
    thousand_5: "五千百",
    thousand_6: "六千百",
    thousand_7: "七千百",
    thousand_8: "八千百",
    thousand_9: "九千百",
  },
  {
    ten_romaji: "0",
    ten_romaji_top: "rē",
    hundred_romaji: "0",
    hundred_romaji_top: "rē",
    thousand_romaji: "0",
    thousand_romaji_top: "rē",
    ten_alternative: "[1]",
    ten_1: "零",
    ten_2: "十",
    ten_3: "二十",
    ten_4: "三十",
    ten_5: "四十",
    ten_6: "五十",
    ten_7: "六十",
    ten_8: "七十",
    ten_9: "八十",
    ten_10: "九十",
    hundred_1: "百",
    hundred_2: "二百",
    hundred_3: "三百",
    hundred_4: "四百",
    hundred_5: "五百",
    hundred_6: "六百",
    hundred_7: "七百",
    hundred_8: "八百",
    hundred_9: "九百",
    thousand_1: "千",
    thousand_2: "二千",
    thousand_3: "三千",
    thousand_4: "四千",
    thousand_5: "五千",
    thousand_6: "六千",
    thousand_7: "七千",
    thousand_8: "八千",
    thousand_9: "九千",
  },
];

export default kanjiNumbers;
